/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbaySetupReq
 */
export interface AdminEbaySetupReq {
    /**
     * HandlingTimeDays: business days to ship after payment, 1 to 5.
     * @type {number}
     * @memberof AdminEbaySetupReq
     */
    handlingTimeDays: number;
    /**
     * ShipFromPostalCode is the 5-digit ZIP code listings ship from.
     * @type {string}
     * @memberof AdminEbaySetupReq
     */
    shipFromPostalCode: string;
}

export function AdminEbaySetupReqFromJSON(json: any): AdminEbaySetupReq {
    return AdminEbaySetupReqFromJSONTyped(json, false);
}

export function AdminEbaySetupReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbaySetupReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'handlingTimeDays': json['handlingTimeDays'],
        'shipFromPostalCode': json['shipFromPostalCode'],
    };
}

export function AdminEbaySetupReqToJSON(value?: AdminEbaySetupReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'handlingTimeDays': value.handlingTimeDays,
        'shipFromPostalCode': value.shipFromPostalCode,
    };
}

